export const CONSTANTS = {
    ALLOWED_ORIGINS: ["https://www.1mg.com", "https://venus.1mg.com"],
    RETRY_ERROR: "Please retry after some time",
    CTA_LABEL: "Avail your benefits",
}
